(function () {
  const THRESHOLD = 35; // swipe px
  const FADE_MS = 180;  // match CSS transition
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n));

  function parseImages(root) {
    const json = root.querySelector('script[data-images]');
    if (!json) return null;
    try { return JSON.parse(json.textContent); } catch (e) { return null; }
  }

  function getPrimary(root) {
    return root.querySelector('.product-card__image--primary');
  }

  // ---------------------------
  // Progress indicator
  // ---------------------------
  function ensureProgress(root, count) {
    const progress = root.querySelector('[data-progress]');
    if (!progress) return;
    if (progress.children.length === count) return;

    progress.innerHTML = '';
    for (let i = 0; i < count; i++) progress.appendChild(document.createElement('span'));
  }

  function updateProgress(root, idx) {
    const progress = root.querySelector('[data-progress]');
    if (!progress) return;

    [...progress.children].forEach((el, i) => {
      el.classList.toggle('is-active', i === idx);
    });
  }

  // ---------------------------
  // Preload (fixes 1s delay)
  // ---------------------------
  const preloadCache = new Map(); // url -> Image()
  function preload(url) {
    if (!url || preloadCache.has(url)) return;
    const img = new Image();
    img.decoding = 'async';
    img.loading = 'eager';
    img.src = url;
    preloadCache.set(url, img);
  }

  function preloadNeighbors(images, idx) {
    const count = images.length;
    if (count <= 1) return;

    const next = images[clamp(idx + 1, 0, count - 1)];
    const prev = images[clamp(idx - 1, 0, count - 1)];

    if (next && next.src) preload(next.src);
    if (prev && prev.src) preload(prev.src);
  }

  // ---------------------------
  // Crossfade overlay buffer
  // (append to wrapper, not link)
  // ---------------------------
  function getOrCreateFadeImg(root) {
    let fade = root.querySelector('img.pc-media-fade-img');
    if (fade) return fade;

    fade = document.createElement('img');
    fade.className = 'pc-media-fade-img';
    fade.alt = '';
    fade.loading = 'eager';
    fade.decoding = 'async';

    // IMPORTANT: attach to wrapper so it covers the true image area
    root.appendChild(fade);
    return fade;
  }

  async function crossfadeTo(root, item) {
    const primary = getPrimary(root);
    const fade = getOrCreateFadeImg(root);
    if (!primary || !fade || !item) return;

    // Put next image into buffer
    fade.src = item.src;
    if (item.srcset) fade.srcset = item.srcset;
    fade.alt = (typeof item.alt === 'string' ? item.alt : (primary.alt || ''));

    // Wait for decode to avoid flashing
    try {
      if (fade.decode) await fade.decode();
    } catch (e) {
      // ok to continue if decode fails
    }

    // Fade in overlay
    fade.classList.add('is-visible');

    // After fade duration: swap primary and hide overlay
    window.setTimeout(() => {
      primary.src = item.src;
      if (item.srcset) primary.srcset = item.srcset;
      if (typeof item.alt === 'string') primary.alt = item.alt;

      fade.classList.remove('is-visible');
    }, FADE_MS + 10);
  }

  // ---------------------------
  // State / switching
  // ---------------------------
  function setIndex(root, idx, animate) {
    const images = parseImages(root);
    if (!images || images.length <= 1) return;

    const count = images.length;
    idx = clamp(idx, 0, count - 1);
    root.dataset.currentIndex = String(idx);

    ensureProgress(root, count);
    updateProgress(root, idx);
    preloadNeighbors(images, idx);

    const item = images[idx];

    if (animate) {
      crossfadeTo(root, item);
    } else {
      const primary = getPrimary(root);
      if (!primary) return;
      primary.src = item.src;
      if (item.srcset) primary.srcset = item.srcset;
      if (typeof item.alt === 'string') primary.alt = item.alt;
    }
  }

  function step(root, dir, animate) {
    const current = parseInt(root.dataset.currentIndex || root.dataset.initialIndex || '0', 10);
    setIndex(root, current + dir, animate);
  }

  function bind(root) {
    const images = parseImages(root);
    if (!images || images.length <= 1) return;

    // init state
    root.dataset.currentIndex = root.dataset.initialIndex || '0';

    ensureProgress(root, images.length);
    updateProgress(root, parseInt(root.dataset.currentIndex, 10));
    preloadNeighbors(images, parseInt(root.dataset.currentIndex, 10));

    // Desktop arrows => crossfade
    const prevBtn = root.querySelector('[data-prev]');
    const nextBtn = root.querySelector('[data-next]');

    if (prevBtn) {
      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        step(root, -1, true);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        step(root, +1, true);
      });
    }

    // Mobile swipe (instant for snappiness; can be true if you want fade on swipe too)
    let startX = 0;
    let startY = 0;
    let moved = false;

    root.addEventListener('touchstart', (e) => {
      const t = e.touches && e.touches[0];
      if (!t) return;
      startX = t.clientX;
      startY = t.clientY;
      moved = false;
    }, { passive: true });

    root.addEventListener('touchmove', (e) => {
      const t = e.touches && e.touches[0];
      if (!t) return;

      const dx = t.clientX - startX;
      const dy = t.clientY - startY;

      if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 10) {
        moved = true;
        e.preventDefault();
      }
    }, { passive: false });

    root.addEventListener('touchend', (e) => {
      if (!moved) return;
      const t = e.changedTouches && e.changedTouches[0];
      if (!t) return;

      const dx = t.clientX - startX;
      if (Math.abs(dx) >= THRESHOLD) {
        step(root, dx < 0 ? +1 : -1, false);
      }
    }, { passive: true });
  }

  function init() {
    document.querySelectorAll('[data-product-media-switch]').forEach(bind);
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();